import { render, staticRenderFns } from "./CapturaDocumentosAdicional.vue?vue&type=template&id=2efc805c&scoped=true&"
import script from "./CapturaDocumentosAdicional.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentosAdicional.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentosAdicional.vue?vue&type=style&index=0&id=2efc805c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efc805c",
  null
  
)

export default component.exports